import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from '@material-ui/core';
import { CSSProperties } from 'react';

const TITLE_FONT_SIZE = 16;
const SMALL_FONT_SIZE = 12;
const DEFAULT_FONT_SIZE = 14;

const getFontSize = ({ title, small }: Pick<TypographyProps, 'title' | 'small'>) => {
  if (title) {
    return TITLE_FONT_SIZE;
  }
  if (small) {
    return SMALL_FONT_SIZE;
  }
  return DEFAULT_FONT_SIZE;
};

interface TypographyProps extends Omit<MuiTypographyProps, 'title' | 'style' | 'className' | 'children'> {
  bold?: boolean;
  italic?: boolean;
  title?: boolean;
  small?: boolean;
  children?: React.ReactNode;
  style?: CSSProperties;
  className?: string;
}

export const Typography = ({ bold, italic, title, small, children, style, className, ...rest }: TypographyProps) => {
  const isTitle = title === true;
  const fontSize = getFontSize({ title: isTitle, small });
  const typographyStyle: CSSProperties = {
    fontSize,
    ...style,
  };
  if (bold || isTitle) {
    typographyStyle.fontWeight = 'bold';
  }
  if (italic) {
    typographyStyle.fontStyle = 'italic';
  }
  return (
    <MuiTypography style={typographyStyle} className={className} {...rest}>
      {children}
    </MuiTypography>
  );
};
